<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <!-- gofix-default-table -->
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'notification-parameter',
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['notification_parameters']));
            return {
                tableConfig:{
                    name: 'contract-notification-params',
                    controls:{
                        create: false,
                        delete: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'unique_name',
                            label: 'Unique Name',
                            thStyle: "width:250px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'description',
                            label: 'Description',
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        }
                    ]
                },
                tableItems:[],
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("NotificationTemplateController/getParameter", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of notification parameter", "danger");
                        reject();
                    })
            },
        }
    }
</script>